'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFunction = function isFunction(x) {
  return typeof x === 'function';
};

exports.default = function (selector, callback) {
  return function (store) {
    return function (next) {
      return function (action) {
        var returnValue = next(action);

        if (!isFunction(selector)) {
          return returnValue;
        }

        var selected = selector(action);

        if (!selected) {
          return returnValue;
        }

        callback(selected, action, store);

        return returnValue;
      };
    };
  };
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-tap/lib/index.js
 ** module id = 363
 ** module chunks = 0
 **/